module.exports = __webpack_public_path__ + "static/carousel-image-1-a13d62fbddf5048b91d4e3931e7e5844.jpg";